import React, { useState } from 'react'
import { Box, Button, IconButton, Popover, Tooltip } from '@mui/material'
import {
  Phone,
  CalendarMonth,
  Notes,
  Mail,
  ConfirmationNumber,
  BarChart,
  Person,
  Check,
} from '@mui/icons-material'
import PhoneModal from '../../task/PhoneModal'
import EmailModal from '../../task/EmailModal'
import { checkForAccountProvider } from './AccountProviderDialog'
import EventModal from '../../task/EventModal'
import GenericTaskModal from '../../task/GenericTaskModal'
import useCurrentIdentity from '../../../hooks/useCurrentIdentity'
import TaskModalWrapper from '../../task/TaskModalWrapper'
import ActivityModal from './ActivityModal'
import MeetModal from '../../task/MeetModal'
import useAlert from '../../../hooks/useAlert'
import useIsMobile from '../../../hooks/useIsMobile'

const Actions = ({
  customer,
  contact,
  handleCreateNewTicket,
  handleClosePopover,
}) => {
  const { currentIdentity, setCurrentIdentity } = useCurrentIdentity()

  const [currentOpenModal, setCurrentOpenModal] = useState(null)

  const checkForAccountProviderThenOpenModal = (modal) => {
    if (currentIdentity.accountProviderId) return setCurrentOpenModal(modal)

    checkForAccountProvider()
      .then((accountProviderId) => {
        setCurrentIdentity({ ...currentIdentity, accountProviderId })

        setCurrentOpenModal(modal)
      })
      .catch(() => {
        setCurrentOpenModal(modal)
      })
  }

  const onClickPhone = () => {
    setCurrentOpenModal('phone')
  }

  const onClickEmail = () => {
    checkForAccountProviderThenOpenModal('email')
  }

  const onClickCalendar = () => {
    checkForAccountProviderThenOpenModal('event')
  }

  const onClickMeet = () => {
    checkForAccountProviderThenOpenModal('meet')
  }

  const onClickActivities = () => {
    setCurrentOpenModal('activities')
  }

  const onClickNote = () => setCurrentOpenModal('general')

  const onCloseModal = () => setCurrentOpenModal(null)

  const { createAlert } = useAlert()
  const onSave = () => {
    handleClosePopover?.()
    setCurrentOpenModal(null)
    createAlert({ message: 'Task created successfully' })
  }

  return (
    <>
      {/* <Tooltip title='Activity Log'>
        <IconButton color={'primary'} onClick={onClickActivities}>
          <BarChart sx={{ fontSize: '30px' }} />
        </IconButton>
      </Tooltip> */}
      <Tooltip title='Phone Call'>
        <IconButton color={'primary'} onClick={onClickPhone}>
          <Phone sx={{ fontSize: '30px' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title='Send Email'>
        <IconButton color={'primary'} onClick={onClickEmail}>
          <Mail sx={{ fontSize: '30px' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title='Create Event'>
        <IconButton color={'primary'} onClick={onClickCalendar}>
          <CalendarMonth sx={{ fontSize: '30px' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title='Meet in person'>
        <IconButton color={'primary'} onClick={onClickMeet}>
          <Person sx={{ fontSize: '30px' }} />
        </IconButton>
      </Tooltip>
      <Tooltip title='General Task'>
        <IconButton color={'primary'} onClick={onClickNote}>
          <Check sx={{ fontSize: '30px' }} />
        </IconButton>
      </Tooltip>

      <Tooltip title='Create Ticket'>
        <IconButton color={'primary'} onClick={handleCreateNewTicket}>
          {/* Ticket */}
          <ConfirmationNumber fontSize='large' />
        </IconButton>
      </Tooltip>

      <ActivityModal
        customerContactId={contact?.id}
        isOpen={currentOpenModal === 'activities'}
        onSave={() => setCurrentOpenModal(null)}
        onClose={() => setCurrentOpenModal(null)}
      />

      {/* TECH-DEBT: theres a better way to do this lol */}
      {currentOpenModal === 'phone' && (
        <TaskModalWrapper
          Component={PhoneModal}
          isOpen={currentOpenModal === 'phone'}
          onSave={onSave}
          onClose={() => setCurrentOpenModal(null)}
          contact={contact}
          customer={customer}
        />
      )}

      {currentOpenModal === 'email' && (
        <TaskModalWrapper
          Component={EmailModal}
          isOpen={currentOpenModal === 'email'}
          onSave={onSave}
          onClose={() => setCurrentOpenModal(null)}
          contact={contact}
          customer={customer}
        />
      )}

      {currentOpenModal === 'event' && (
        <TaskModalWrapper
          Component={EventModal}
          isOpen={currentOpenModal === 'event'}
          onSave={onSave}
          onClose={() => setCurrentOpenModal(null)}
          contact={contact}
          customer={customer}
        />
      )}

      {currentOpenModal === 'meet' && (
        <TaskModalWrapper
          Component={MeetModal}
          isOpen={currentOpenModal === 'meet'}
          onSave={onSave}
          onClose={() => setCurrentOpenModal(null)}
          contact={contact}
          customer={customer}
        />
      )}

      {currentOpenModal === 'general' && (
        <TaskModalWrapper
          Component={GenericTaskModal}
          isOpen={currentOpenModal === 'general'}
          onSave={onSave}
          onClose={() => setCurrentOpenModal(null)}
          contact={contact}
          customer={customer}
        />
      )}
    </>
  )
}

const ActionsWrapper = (props) => {
  const isMobile = useIsMobile()
  const [anchorEl, setAnchorEl] = useState(null)

  if (!isMobile) return <Actions {...props} />

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <>
      <Button variant='contained' onClick={handleClick}>
        Tasks
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Actions {...props} handleClosePopover={handleClose} />
      </Popover>
    </>
  )
}

export default ActionsWrapper
